import { render, staticRenderFns } from "./followupDialog.vue?vue&type=template&id=297ac7ac&scoped=true"
import script from "./followupDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./followupDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./followupDialog.vue?vue&type=style&index=0&id=297ac7ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297ac7ac",
  null
  
)

export default component.exports